import { effect, stop } from '@vue/reactivity'
import { evaluateInScope } from '../component/utils'

export default {

    signature: 'qv-text',

    handle(node, scope) {

        if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('${')) {

            const mustacheRegex = /\$\{\s*([\w.]+)\s*\}/g
            // Store original template text
            const originalText = node.textContent

            const runner = effect(() => {
                node.textContent = originalText.replace(mustacheRegex, (_, expression) => evaluateInScope(expression, scope))
            })

            return () => {
                stop(runner)
            }

        }

        if (node.hasAttribute('qv-for')) {
            return null
        }

        if (node.hasAttribute(this.signature)) {

            const expression = node.getAttribute(this.signature)

            const runner = effect(() => {
                node.textContent = evaluateInScope(expression, scope)
            })

            return () => {
                stop(runner)
            }

        }

        return null

    },

}
